import { useMemo } from "react";
import {
  DatePicker,
  FilterInput,
  NumericInput,
  SelectInput,
  VinInput
} from "@dealer-center/core-components";
import type { FilterFieldProps } from "@dealer-center/ddc-pages-inventory-archiver-interface";

const FilterField = ({ config, value, onChange }: FilterFieldProps) => {
  const dateValue = useMemo(() => (value ? new Date(value) : null), [value]);

  switch (config.type) {
    case "select":
      return (
        <SelectInput
          label={config.label}
          name={config.name}
          options={config.options}
          value={value}
          onChange={e => onChange(e.target?.value ?? "")}
        />
      );
    case "date":
      return (
        <DatePicker
          dateFormat="yyyy-MM-dd"
          label={config.label}
          name={config.name}
          value={dateValue}
          onChange={e => onChange(e.target?.value?.dateValue ?? "")}
        />
      );
    case "number":
      return (
        <NumericInput
          allowDecimal={true}
          allowNegative={true}
          autoInsertCommas={false}
          label={config.label}
          name={config.name}
          value={value}
          onChange={e => onChange(e.target?.value ?? "")}
        />
      );
    case "vin":
      return (
        <VinInput
          label={config.label}
          name={config.name}
          value={value}
          onChange={e => onChange(e.target?.value ?? "")}
        />
      );
    case "boolean":
      return (
        <SelectInput
          label={config.label}
          name={config.name}
          options={[
            { value: "", label: "Any" },
            { value: "true", label: "True" },
            { value: "false", label: "False" }
          ]}
          value={value}
          onChange={e => onChange(e.target?.value ?? "")}
        />
      );
    case "string":
    default:
      return (
        <FilterInput
          clearButton
          label={config.label}
          name={config.name}
          value={value}
          onChange={e => onChange(e.target?.value?.trim() ?? "")}
        />
      );
  }
};

export default FilterField;
